import React from 'react';
import { Trans } from 'react-i18next';
import { TFunction } from 'i18next';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { useGlobalState } from '../../../state/persistence';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    highlight: {
      color: theme.palette.secondary.main,
      fontWeight: 700,
      textDecoration: 'none',
      [theme.breakpoints.down('xs')]: {
        color: 'inherit ',
      },
    },
  }),
);

const useGetTitle = (t: TFunction, amount: number) => {
  const { question } = useGlobalState();
  const classes = useStyles();
  return (
    <Trans
      t={t}
      i18nKey="title"
      values={{
        apartmentSize: question.apartmentSize,
        postalCode: question.postcode,
        amount,
      }}
    >
      <span className={classes.highlight}>size</span>
      <span className={classes.highlight}>postalCode</span>
      <span className={classes.highlight}>amount</span>
    </Trans>
  );
};

export default useGetTitle;
